import { Skeleton } from "@/components/ui/skeleton";

const BookingDetailsSkeleton = () => {
  return (
    <div className="min-h-screen bg-muted/30">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-background border-b border-border px-4 py-3">
        <div className="flex items-center gap-3">
          <Skeleton className="w-8 h-8 rounded-lg" />

          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-3 w-28" />
          </div>

          <Skeleton className="h-6 w-20 rounded-full" />
        </div>
      </div>

      <div className="p-4 space-y-4">

        {/* Customer Info */}
        <div className="bg-background border border-border rounded-2xl p-4 space-y-3">
          <Skeleton className="h-3 w-40" />

          <div className="space-y-2.5">
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-52" />
          </div>
        </div>

        {/* Booking Info */}
        <div className="bg-background border border-border rounded-2xl p-4 space-y-3">
          <Skeleton className="h-3 w-40" />

          <div className="grid grid-cols-2 gap-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="flex items-start gap-2.5">
                <Skeleton className="w-8 h-8 rounded-lg" />

                <div className="space-y-1.5">
                  <Skeleton className="h-3 w-16" />
                  <Skeleton className="h-4 w-24" />
                  {i === 2 && <Skeleton className="h-3 w-32" />}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Payment Info */}
        <div className="bg-background border border-border rounded-2xl p-4 space-y-3">
          <Skeleton className="h-3 w-40" />

          <div className="space-y-3">
            <div className="flex justify-between">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-6 w-24" />
            </div>

            <div className="flex justify-between">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-4 w-28" />
            </div>

            <div className="flex justify-between">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-5 w-20 rounded-full" />
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <Skeleton className="h-10 flex-1 rounded-xl" />
          <Skeleton className="h-10 flex-1 rounded-xl" />
        </div>
      </div>
    </div>
  );
};

export default BookingDetailsSkeleton;
